import { InjectionToken } from "@angular/core";

export const ASSETS_URL = new InjectionToken<string>('https://paetep.edulinksolutions.com/assets');